module.exports = __webpack_public_path__ + "img/testRanking.c2728af4.jpg";